<template>
  <v-expansion-panel v-if="getDisplayType === 'item'">
    <v-expansion-panel-header class="pa-0 pr-5">
      <v-list-item>
        <v-list-item-avatar class="mr-3">
          <v-icon size="20px">fal fa-clipboard</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle>
            <span class="d-inline-block text-truncate mr-4">{{ printDate }}</span>
            <span class="d-inline-block text-truncate" :style="`max-width:${ $vuetify.breakpoint.smAndUp ? 250 : 150}px`">{{ printExcerpt }}</span>
          </v-list-item-subtitle>
          <v-list-item-title>
            <MarkTag :text="printTitle" :match="getQuery" />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <template v-slot:actions>
        <v-icon>fal fa-angle-down</v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="pb-0">
      <Layout :item="getItem" />
      <v-divider></v-divider>
      <v-list-item class="grow">
        <v-list-item-content>
          <v-list-item-title class="caption" :class="{ 'teal--text': didIPost, 'text--darken-2': didIPost }">
            <v-icon x-small>fa-user-edit</v-icon>&nbsp;{{ `${printAuthor}` }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            v-if="didIPost"
            color="secondary"
            :icon="$vuetify.breakpoint.smAndDown"
            :outlined="$vuetify.breakpoint.mdAndUp"
            :loading="isLoading"
            @click.stop="edit">
            <v-icon small :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }">fal fa-pencil</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">編集する</span>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-expansion-panel-content>
  </v-expansion-panel>
  <v-card v-else color="white" class="mb-3">
    <v-card-title class="title pa-0">
      <v-list-item dense>
        <v-list-item-content>
          <MarkTag :text="printTitle" :match="getQuery" />
        </v-list-item-content>
        <v-list-item-action>
          <v-menu left>
            <template v-slot:activator="{ on }">
              <v-btn text fab small
                v-on="on"
                color="secondary"
                :loading="isLoading">
                <v-icon small>fas fa-ellipsis-v</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="openMailer">
                <v-list-item-avatar>
                  <v-icon small color="secondary">fal fa-envelope</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>メールする</v-list-item-content>
              </v-list-item>
              <v-list-item v-if="didIPost" @click="remove()">
                <v-list-item-avatar>
                  <v-icon small color="red">fal fa-trash-alt</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>削除する</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="body-1 text-xs-left">
      <Layout :item="getItem" />
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="grey lighten-4">
      <v-list-item class="grow">
        <v-list-item-content>
          <v-list-item-title class="caption" :class="{ 'teal--text': didIPost, 'text--darken-2': didIPost }">
            <v-icon x-small>fa-user-edit</v-icon>&nbsp;{{ `${printAuthor}（${printDate}）` }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            v-if="didIPost"
            color="secondary"
            :icon="$vuetify.breakpoint.smAndDown"
            :outlined="$vuetify.breakpoint.mdAndUp"
            :loading="isLoading"
            @click.stop="edit">
            <v-icon small :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }">fal fa-pencil</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">編集する</span>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card-actions>
    <MangoMailer ref="mailer" />
    <Confirmer ref="confirmer" />
  </v-card>
</template>

<script>
import MarkTag from '@/components/tags/mark'
import Confirmer from '@/components/modals/confirm'
import MangoMailer from '@/components/mailer'
import Layout from './layout'
export default {
  name: 'posterRecord',
  components: {
    MarkTag,
    MangoMailer,
    Confirmer,
    Layout
  },
  props: [
    'item',
    'cid',
    'display',
    'authors'
  ],
  data () {
    return {
      config: {
        status: {
          loading: false
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    edit: function () {
      if (this.$props.item) {
        this.$emit('emit', {
          action: 'edit',
          data: this.$props.item
        })
      }
    },
    remove: function () {
      this.$refs.confirmer.open({
        message: 'この投稿を削除してもよろしいですか？',
        callback: () => {
          this.submit({ type: 'remove' })
        }
      })
    },
    preSubmit: function (req) {
      const { type } = req || {}
      const { id } = this.$props.item
      const aid = this.$store.getters['author/get']('userid')
      const cid = this.$route.params.id
      const urls = {
        remove: `${this.$url.api}posts/remove/item/${id}`
      }
      const fds = {
        remove: { cid, aid, type: 'record' }
      }
      if (type && urls[type] && fds[type]) {
        if (type === 'remove') {
          const url = urls[type]
          const fd = fds[type]
          this.$set(this.config.status, 'loading', true)
          return { url, fd, type }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd, type } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data, type)
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req, postType) {
      const socket = this.$store.getters['config/get']('socket')
      const type = postType || ''
      if (postType === 'remove') {
        socket.emit('POST_POST', req, (res) => {
          console.log(res)
          this.$set(this.config.status, 'loading', false)
        })
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    },
    openMailer: function () {
      const { title, content, attachments } = this.$props.item
      this.$refs.mailer.open({
        title, content, attachments
      })
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    getClientId () {
      return this.$route.params.id || this.$props.cid || ''
    },
    getDisplayType () {
      return this.$props.display || 'card'
    },
    getQuery () {
      return this.$route.query && this.$route.query.query
    },
    getItem () {
      return this.$props.item || {}
    },
    printTitle () {
      const { title } = this.$props.item
      return title || ''
    },
    printExcerpt () {
      return this.$props.item ? this.$props.item.content.replace(/\n/g, '').substring(0, 20) : ''
    },
    printAuthor () {
      return (
        this.$props.item &&
        this.$props.item.aid &&
        this.$props.authors &&
        this.$props.authors[this.$props.item.aid]
      ) ? this.$props.authors[this.$props.item.aid].name[0] : ((this.$props.item && this.$props.item.aid) ? this.$props.item.aid : '')
    },
    printDate () {
      return (
        this.$props.item &&
        this.$props.item.date
      ) ? this.$moment(this.$props.item.date).format('YYYY年MM月DD日') : ''
    },
    didIPost () {
      return (
        this.$props.item &&
        this.$props.item.aid &&
        (this.$props.item.aid === 'guest' || this.$props.item.aid === this.$store.getters['author/get']('userid') || this.$store.getters['author/get']('roles').includes('developer'))
      )
    }
  }
}
</script>
